export const OPEN_HOME_PAGE_BANNER = 'openHomePageBanner';

export const ACT_ON_BEHALF = 'ACT_ON_BEHALF';

export const PORTAL_VERSION = 'PORTAL_VERSION';
export const MARKETPLACE_TOKEN = 'MARKETPLACE_TOKEN';

export const PORTAL_CONFIG = 'PORTAL_CONFIG';

export const TRACKING_PATH = 'TRACKING_PATH';
export const DIGITAL_ASSISTANT_CARD_KNOWLEDGE = 'DIGITAL_ASSISTANT_CARD_KNOWLEDGE';
